module.exports = __webpack_public_path__ + "img/forecast_profile.10122aae.png";